import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Button, Accordion } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getApi } from "../../actions/structure.action";
import isEmpty from "../../utils/is-Empty";
import Spinner from "../common/Spinner";
import RefferSection from "../common/RefferSection";
import TimestampConverter from "../../utils/TimestampConverter";
import EnquirySummaryCard from "./EnquirySummaryCard";

import "./enquiry.css";

function Enquiry() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [buyerAddress, setBuyerAddress] = useState({});
  const { enquiry, auth, addresses, sellerAddress } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getApi("getAddressess", dispatch);
  }, []);

  useEffect(() => {
    getApi("getEnquiry", dispatch, "/" + id);
  }, [id]);

  useEffect(() => {
    console.log("addresses", addresses);
    if (!isEmpty(addresses.data) && addresses.data.length > 0) {
      let defaultAddress = addresses.data.filter((el) => el.set_default === 1);
      if (defaultAddress && defaultAddress.length > 0) {
        setBuyerAddress(defaultAddress[0]);
      } else {
        setBuyerAddress(addresses.data[0]);
      }
    }
  }, [addresses]);

  useEffect(() => {
    if (!isEmpty(enquiry?.data?.seller_id)) {
      getApi("getSellerAddress", dispatch, "/" + enquiry?.data?.seller_id);
    }
  }, [enquiry]);

  const enquiryBanner = (
    <div className="order-banner-main-div text-uppercase desktop">
      <p>
        <Link to={`/`}>{"Home"}</Link>
      </p>
      <h2>{"Enquiry"}</h2>
    </div>
  );

  return (
    <section className="order-main-section">
      {enquiryBanner}

      {(() => {
        if (!enquiry.loading && !isEmpty(enquiry?.data)) {
          return (
            <Container className="py-4">
              <div className="order-section-title-div">
                <h4 className="order-section-title m-0">{"Enquiry Details"}</h4>
              </div>
              <div id="borderLeft"></div>
              <Row className="m-0 py-2 order-info">
                <Col xs={12} sm={12} md={8} lg={8} className="p-0 text-start">
                  <div>
                    <p className="m-0">
                      Enquiry ID: <span># {enquiry?.data?.enquiry_id}</span>{" "}
                    </p>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} className="p-0 left-col">
                  <div>
                    <p className="m-0">
                      Enquiry Date:{" "}
                      <span>{TimestampConverter(enquiry?.data?.enquiryCreatedAt)}</span>{" "}
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="m-0 py-2">
                <Col xs={12} sm={12} md={8} lg={8} className="p-0">
                  <EnquirySummaryCard card={enquiry?.data} />
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} className="p-0 left-col">
                  <div>
                    <p className="m-0">
                      <strong>Enquiry Status:</strong>{" "}
                      <span class="text-uppercase">{enquiry?.data?.enquiry_status}</span>{" "}
                    </p>
                  </div>
                  {enquiry?.data?.accepted_at && (
                    <div>
                      <p className="m-0">
                        <strong>Accepted Date:</strong>{" "}
                        <span>{TimestampConverter(enquiry?.data?.accepted_at)}</span>{" "}
                      </p>
                    </div>
                  )}
                </Col>
              </Row>
              <Row className="m-0 py-2">
                <Col xs={12} sm={12} md={6} lg={6} className="p-0 text-start">
                  <div>
                    <h5 className="order-section-title m-0">{"Delivery Address"}</h5>
                  </div>
                  <div id="borderLeft"></div>
                  <div className="mt-1 text-start">
                    <p className="m-0">{auth?.user?.business_name}</p>
                    <p className="m-0">
                      {buyerAddress?.address_line_1}
                      {!isEmpty(buyerAddress?.address_line_2)
                        ? ", " + buyerAddress?.address_line_2
                        : ""}
                      {!isEmpty(buyerAddress?.address_line_3)
                        ? ", " + buyerAddress?.address_line_3
                        : ""}
                      {", " + buyerAddress?.city}
                      {", " + buyerAddress?.state}
                      {", " + buyerAddress?.country}
                    </p>
                    <p className="m-0">Pin code: {buyerAddress?.pin_code}</p>
                    <p className="m-0">Contact: {buyerAddress?.primary_number}</p>
                  </div>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  className="p-0 text-start"
                  style={{ display: "none" }}
                >
                  <div>
                    <h5 className="order-section-title m-0">{`Seller Address (${sellerAddress?.data?.type_name})`}</h5>
                  </div>
                  <div id="borderLeft"></div>
                  <div className="mt-1 text-start">
                    <p className="m-0">{sellerAddress?.data?.full_name}</p>
                    <p className="m-0">
                      {sellerAddress?.data?.address_line_1}
                      {!isEmpty(sellerAddress?.data?.address_line_2)
                        ? ", " + sellerAddress?.data?.address_line_2
                        : ""}
                      {!isEmpty(sellerAddress?.data?.address_line_3)
                        ? ", " + sellerAddress?.data?.address_line_3
                        : ""}
                      {", " + sellerAddress?.data?.city}
                      {", " + sellerAddress?.data?.state}
                      {", " + sellerAddress?.data?.country}
                    </p>
                    <p className="m-0">Pin code: {sellerAddress?.data?.pin_code}</p>
                    <p className="m-0">Contact: {sellerAddress?.data?.primary_number}</p>
                  </div>
                </Col>
              </Row>
            </Container>
          );
        } else if (enquiry.loading) {
          return <Spinner />;
        }
      })()}

      <RefferSection />
    </section>
  );
}

export default Enquiry;
